// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__eOWhl","requiredAsterisk":"Info_requiredAsterisk__xmrHu"};